import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import styled from '@mui/styles/styled';

const HeaderContainer = styled('div')({});

function SectionHeader({ TypographyProps = {}, children, ...props }) {
	return (
		<HeaderContainer {...props}>
			<Typography variant="heading6">{children}</Typography>
		</HeaderContainer>
	);
}

SectionHeader.propTypes = {
	TypographyProps: PropTypes.any,
	children: PropTypes.any,
};

export default React.memo(SectionHeader);
